// index.ts
import { createI18n } from 'vue-i18n'
import zh from './zh'
import en from './en'

const messages = {
	en,
	zh
};

const i18n = createI18n({
    legacy: false, // 兼容旧版本
	locale: localStorage.getItem('lang') || 'zh', // 首先从缓存里拿，没有的话就用浏览器语言，
	messages
});

export default i18n;
